module.exports = __webpack_public_path__ + "static/media/7a.444b8a9c.jpg";